import ApiService from '@/plugins/apiService'

export default {
  state: {
    instructions: []
  },

  mutations: {
    SET_INSTRUCTIONS (state, instructions) {
      state.instructions = instructions
    }
  },

  actions: {
    fetchInstructions ({ commit }) {
      return ApiService.getInstructions()
        .then(data => {
          commit('SET_INSTRUCTIONS', data)
        })
    },
    fetchInstructionByID ({ commit }, ID) {
      return ApiService.getInstructionByID(ID)
        .then(data => {
          return data
        })
    }
  },

  getters: {
    getInstructionsCount (state) {
      return state.instructions.length
    },
    getInstructionsByCategory: state => id => {
      return state.instructions
    }
  }
}